import script from "./QuoteEventBasics.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteEventBasics.vue?vue&type=script&setup=true&lang=js"

import "./QuoteEventBasics.vue?vue&type=style&index=0&id=6f514747&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f514747"]])

export default __exports__